
import { defineComponent } from "vue";

export default defineComponent({
  name: "delete-file-button"
});
